<script>
export default {
	name: "ClubPage",
	components: {},

	data() {
		return {
			activeModal: "",
			cardBoxes: [
				{
					icon: "currency-dollar",
					title: "Cost-Efficient and Effective Broadcasting",
					text: "Deliver professional-level live streaming and highlights without breaking the bank.",
				},

				{
					icon: "facesmile",
					title: "Audience Engagement",
					text: "Expand tournament visibility globally through Sport.Video's live streaming and highlights capabilities.",
				},

				{
					icon: "linechart",
					title: "Monetization Opportunities",
					text: "Unlock revenue streams by activating sponsors during live events and highlight broadcasts.",
				},
				{
					icon: "telescope",
					title: "Player Showcase and Development",
					text: "Spotlight player talents through Sport.Video's video highlights and live streaming features.",
				},

				{
					icon: "magic-wand",

					title: "Seamless Integration",
					text: "Create your online TV and integrate Sport.Video into tournament web page or mobile app.",
				},

				{
					icon: "target",
					title: "Fan Engagement",
					text: "Immerse fans in the heart of tournament action with exclusive live streaming and highlight experiences.",
				},
			],

			roles: [
				{
					title: "Tournament Organizer",
					text: "Streamline tournament logistics for an unforgettable experience.",
					image: "/static/images/role-img9.jpg",
					modal: "tournament",
				},

				{
					title: "Broadcast Coordinator",
					text: "Transform  the tournament viewing with live streaming and highlight broadcasts.",
					image: "/static/images/role-img10.jpg",
					modal: "broadcast",
				},

				{
					title: "Marketing and Media",
					text: "Maximize tournament reach through effective promotion.",
					image: "/static/images/role-img8.jpg",
					modal: "marketing",
				},

				{
					title: "Fans",
					text: "Ensure immersive and engaging experience for your fans. Anytime, anywhere.",
					image: "/static/images/role-img-fans.jpg",
					modal: "fans",
				},
			],

			modalTournamentCards: [
				{
					icon: "currency-dollar",
					title: "Efficient Coverage",
					text: "Elevate your coverage while optimizing resources for an unparalleled and efficient broadcasting experience.",
				},

				{
					icon: "globe",
					title: "Global Reach",
					text: "Utilize Sport.Video's live streaming and highlights features to extend tournament visibility globally.",
				},

				{
					icon: "linechart",
					title: "Sponsorship Activation",
					text: "Maximize sponsorship engagement by showcasing sponsors dynamically during live events and highlights.",
				},
			],
			modalBroadcastCards: [
				{
					icon: "facesmile",
					title: "Broadcasting Integration",
					text: "Enhance the viewer experience with seamless and engaging tournament coverage.",
				},

				{
					icon: "dataflow2",
					title: "Dynamic Highlights",
					text: "Create captivating highlight reels using Sport.Video's technology to showcase key moments.",
				},

				{
					icon: "eye",
					title: "Fan Interaction",
					text: "Foster a more immersive and participatory viewing experience for fans.",
				},
			],

			modalMarketingCards: [
				{
					icon: "dataflow2",
					title: "Strategic Content Creation",
					text: "Use Sport.Video content that enhances the tournament's online presence.",
				},

				{
					icon: "globe",
					title: "Promotion Opportunities",
					text: "Leverage Sport.Video's broadcasting features to extend tournament promotion globally.",
				},

				{
					icon: "currency-dollar",
					title: "Monetization Strategies",
					text: "Unlock revenue streams through monetization tools during tournament broadcasts.",
				},
			],

			modalFansCards: [
				{
					icon: "users",
					title: "Community Building",
					text: "Engage with fans who share your passion for the tournament.",
				},

				{
					icon: "share",
					title: "Social Media Sharing",
					text: "Easily share tournament highlights, memorable moments, and insights on social media directly from Sport.Video.",
				},

				{
					icon: "magic-wand",
					title: "Interactive Experience",
					text: "Experience the tournament like never before, with interactive features that put you at the center of the excitement.",
				},
			],
			faqData: [
				{ id: 1, question: "How does Sport.Video enhance tournament coverage?", answer: "Sport.Video provides efficient coverage solutions, including live streaming and engaging fan interactions, creating an unforgettable tournament experience." },
				{ id: 2, question: "What do we need to livestream our tournament games and create highlights on Sport.Video?", answer: "Live streaming and creating highlights on Sport.Video is straightforward. All you need is a compatible mobile device, a reliable internet connection, and our user-friendly mobile app to broadcast games live and curate exciting highlights effortlessly." },
				{ id: 3, question: "Do we have to use live streaming, or is it possible to create highlights only?", answer: "With Sport.Video, your tournament does not have to use live streaming. You can also decide to focus on highlights production only, even in offline mode and upload them once you have internet connection. Please check <a href='/pricing'>Pricing</a> for our subscription plans." },
				{ id: 4, question: "Can Sport.Video help monetize our tournament broadcasts?", answer: "Yes, Sport.Video offers in-app monetization tools, allowing tournaments to unlock new revenue streams through broadcasts." },
				{ id: 5, question: "Can tournaments monetize content with sponsors and partners through Sport.Video?", answer: "Yes, Sport.Video provides monetization tools during live events and broadcasts, offering tournaments opportunities for revenue generation." },
				{ id: 6, question: "How easy is it to set up a monetization campaign for our tournaments’s content on Sport.Video?", answer: "Setting up a monetization campaign is seamless on Sport.Video. Tournaments can effortlessly configure pre-roll videos, overlay banners, watermarks, post-roll banners, and more to optimize their revenue potential." },
				{ id: 7, question: "Is it possible to access statistics for our tournament's performance on Sport.Video?", answer: "Certainly! Sport.Video provides detailed statistics for tournaments, including viewership data, campaign statistics, fan engagement metrics, and more.x" },
				{
					id: 8,
					question: "What devices can I use for recording and livestreaming?",
					answer: 'The Sport.Video app is compatible with mobile smartphones running iOS 15+ and Android 8+. Please be aware that we currently do not support Huawei devices or devices operating on HarmonyOS. For detailed information on livestreaming requirements and recommendations, please refer <a target="_blank" href="/livestream-requirements">to this page<a>',
				},

				{
					id: 9,
					question: "Does Sport.Video enable us to save the full game video?",
					answer: "Yes, Sport.Video enables you to save the full game video. You can explore our different subscription packages to choose the one that meets your requirements.",
				},

				{
					id: 10,
					question: "What quality of internet do I need to ensure live streaming will work perfectly?",
					answer: "For optimal live streaming performance, we recommend the following internet requirements: 4G/5G mobile connection or WiFi, network latency of 5ms or lower, upload speed of 10 Mbps or higher, and a camera with a resolution of 1080p or higher.",
				},
				{
					id: 11,
					question: "How much data will a live stream consume?",
					answer: "On average, a one-hour live stream will consume between 1 and 2 GB of data.",
				},
          {
          id: 12,
          question: 'How do I use the Multicam feature and how does it work?',
          answer: 'To capture a game from various angles using multiple cameras, please follow steps on this <a target="_blank" href="/multicam">link<a>'
        },
        {
          id: 13,
          question: "Where are full game recordings stored?",
          answer: "If enabled in the app settings, full game recordings are stored on the device itself, giving you complete control over your content. For livestreamed games to social media, you can find the full game video within the social media platform. For livestreamed games to your Sport.Video channel, you can download the recording via the web dashboard or the button underneath the game's video player.",
        },
			],
      testimonials: [
        {
            image: '/static/images/floor.png',
            name: 'Slovak Floorball Cup',
            category: 'Floorball',
            bg_image: '/static/images/floorball.jpg',
            description:
                'We use Sport.Video to add more services and incredible value to all participating teams. It\'s an invaluable tool for improving player performance.',
            bg_color: 'blue',
            link: {
                label: 'Show channel',
                slug: 'slovak-floorball-cup'
            }
        },
        {
            image: '/static/images/cascais.svg',
            name: 'Cascais Futsal Cup',
            category: 'Futsal',
            bg_image: '/static/images/cascaisback.jpg',
            description:
                'Sport.Video elevates the Cascais Futsal Cup with increased visibility, boosting social media engagement and improving our brand.',
            bg_color: 'purple',
            link: {
                label: 'Show channel',
                slug: 'cascais-futsal-cup-tv'
            }
        },
        {
            image: '/static/images/miniportugal.svg',
            name: 'MiniFootball Portugal',
            category: 'Minifootball federation',
            bg_image: '/static/images/miniportback.jpg',
            description:
                'Sport.Video enhances our tournaments by simplifying content creation and improving fan engagement with accessible highlights.',
            bg_color: 'green',
            link: {
                label: 'Show channel',
                slug: 'associacao-portuguesa-de-minifootball'
            }
        },
        {
            image: '/static/images/channel-img.svg',
            name: 'Niké TopLiga',
            category: 'Minifootball',
            bg_image: '/static/images/topliga.jpg',
            description:
                'Sport.Video has transformed our club\'s digital presence. Our fans are thrilled with the real-time highlights!',
            bg_color: 'orange',
            link: {
                label: 'Show channel',
                slug: 'sk-0'
            }
        }
    ]
		};
	},

	methods: {
		showModal(value) {
			this.activeModal = value;
			document.querySelector("html").classList.add("modal-open");
		},

		closeModal() {
			this.activeModal = "";
			document.querySelector("html").classList.remove("modal-open");
		},
	},
};
</script>

<template>
	<div>
		<secondary-hero backgroundImageUrl="/static/images/solutions-tournaments-hero-bg.png" imgUrl="/static/images/solutions-tournaments-hero-img.png" />

		<IntroSectionText>
			<p class="text-primary font-semibold mb-1">For Tournaments</p>
			<h1 class="mb-2">Elevate Your <strong class="d-block">Tournament Experience</strong></h1>
			<div class="row mb-3">
				<div class="col-60 col-lg-30">
					<p>Unleash unforgettable moments of your tournament through live streaming and highlights.</p>
				</div>
			</div>

			<div class="row g-1">
				<div v-for="(cardBox, index) in cardBoxes" :key="index" class="col-60 col-lg-20">
					<CardBox :data="cardBox" />
				</div>
			</div>
		</IntroSectionText>

		<RolesSection>
			<h1 class="mb-2">Every Role <strong class="d-block">Shapes the Victory Story</strong></h1>
			<div class="row mb-3">
				<div class="col-60 col-lg-42">
					<p>Discover tailored benefits that empower each role within your tournament</p>
				</div>
			</div>

			<SwiperSlider>
				<swiper-slide v-for="(role, index) in roles" :key="`roles-item-${index}`">
					<RolesBox :data="role" @showModal="showModal" />
				</swiper-slide>
			</SwiperSlider>
		</RolesSection>

		<MainBanner class="mb-md-6">
			<template #title> One solution to cover a <strong>wide array of sports</strong>.</template>
			<template #text>Sport.Video supports football, futsal, minifootball, ice hockey, floorball, field hockey, ball hockey, handball, american football, rugby and basketball. If your sport isn't listed, reach out to us, and we will customize Sport.Video to meet your specific requirements.</template>
			<template #button>
				<BaseButton to="/about-us#contact" type="btn-primary" size="btn-big" icon-position="end">
					Contact Us
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="ms-1 transition" aria-hidden="true">
						<path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg></BaseButton
			></template>
		</MainBanner>

		<ChannelsSection class="pt-6" :testimonials="testimonials"/>

		<FaqSection class="pt-6" theme="dark" :faqData="faqData" />

		<MainBanner class="pt-6" theme="dark">
			<template #title>
				Engage Fans &<br />
				<strong>Attract Sponsors</strong>
			</template>
			<template #text
				>Join 28,500+ clubs, leagues and federations.<br />
				Unlock new levels of fan engagement and revenue.</template
			>
			<template #button>
				<BaseButton to="/registration/" type="btn-primary" size="btn-big" icon-position="end" ga-event="get_started_product">
					Get Started for Free
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="ms-1 transition" aria-hidden="true">
						<path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg
				></BaseButton>
			</template>

			<template #bottom-text> or <a href="pricing">explore our pricing plans</a> </template>
		</MainBanner>

		<Transition name="fade-down">
			<Modal v-if="activeModal === 'tournament'" @closeModal="closeModal" @click.prevent>
				<template #category>Tournament Organizer</template>

				<template #title>Streamline tournament logistics and create an unforgettable experience for participants and fans.</template>

				<template #content>
					<div class="d-flex gap-1 flex-column flex-md-row">
						<CardBox v-for="cardBox in modalTournamentCards" :data="cardBox" />
					</div>
				</template>
			</Modal>

			<Modal v-if="activeModal === 'broadcast'" @closeModal="closeModal" @click.prevent>
				<template #category>Broadcast Coordinator</template>

				<template #title>Transform the tournament viewing experience with dynamic live streaming and highlight broadcasting through Sport.Video.</template>

				<template #content>
					<div class="d-flex gap-1 flex-column flex-md-row">
						<CardBox v-for="cardBox in modalBroadcastCards" :data="cardBox" />
					</div>
				</template>
			</Modal>

			<Modal v-if="activeModal === 'marketing'" @closeModal="closeModal" @click.prevent>
				<template #category>Marketing and Media</template>

				<template #title>Promote your tournament and maximize its reach.</template>

				<template #content>
					<div class="d-flex gap-1 flex-column flex-md-row">
						<CardBox v-for="cardBox in modalMarketingCards" :data="cardBox" />
					</div>
				</template>
			</Modal>

			<Modal v-if="activeModal === 'fans'" @closeModal="closeModal" @click.prevent>
				<template #category>Fans</template>

				<template #title>Ensure immersive and engaging experience for your fans. Anytime, anywhere.</template>

				<template #content>
					<div class="d-flex gap-1 flex-column flex-md-row">
						<CardBox v-for="cardBox in modalFansCards" :data="cardBox" />
					</div>
				</template>
			</Modal>
		</Transition>
	</div>
</template>
